import { Global, css } from "@emotion/react";
import "@via-ds/tokens/tokens.css";
import {
  bodyStyles,
  fontStyles,
  resetStyles,
} from "@evg-ui/lib/components/styles";

export const globalStyles = css`
  ${fontStyles}
  ${resetStyles}
  background-color: white;

  body {
    ${bodyStyles}

    /* Increase default tab size to make it easier to read logs. */
    tab-size: 4;

    /* Prevent scroll bounce behavior. */
    overscroll-behavior-y: none;
    overscroll-behavior-x: none;

    /* Hide scroll bar on webkit browsers to prevent it from using up page width. */
    ::-webkit-scrollbar {
      display: none;
    }
  }

  [data-via-provider] {
    display: contents;
  }

  /* Ensure toasts appear above the side panel (z-index: 2) */
  .parsley-toast-portal {
    z-index: 10;
  }
`;

export const GlobalStyles = () => <Global styles={globalStyles} />;
